import angular from 'angular';
import beforeBottom from './before-bottom.directive';

export default angular
  .module('verifyApp.before-bottom', [])
  .directive('beforeBottom', beforeBottom)
  .name;



// WEBPACK FOOTER //
// ./client/components/before-bottom/index.js